import React from 'react';

export default ({ width = 32, height = 32, fill = '#FFFFFA' }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 512 512'
			preserveAspectRatio='xMidYMid meet'
		>
			<g
				fill={fill}
				stroke={'none'}
				transform={'translate(0,512) scale(0.100000,-0.100000)'}
			>
				<path d='M2515 3999 c-394 -30 -794 -169 -1123 -391 -182 -123 -419 -343 -536 -498 -82 -108 -106 -130 -143 -130 -36 0 -52 12 -219 172 -70 66 -102 89 -135 98 -96 26 -197 -14 -246 -98 l-28 -47 -3 -917 c-2 -890 -2 -919 17 -955 38 -75 107 -116 191 -116 32 0 69 7 87 16 52 27 1473 857 1515 885 109 72 125 221 35 319 -42 46 -36 43 -288 118 -104 31 -122 43 -122 83 0 38 34 82 161 204 279 268 631 408 1022 408 578 0 1091 -320 1340 -835 92 -190 134 -361 150 -605 5 -83 16 -164 25 -190 37 -103 122 -198 219 -244 212 -100 464 -10 569 203 31 63 32 71 35 203 10 387 -117 836 -336 1192 -406 660 -1073 1067 -1845 1126 -145 11 -194 11 -342 -1z' />
			</g>
		</svg>
	);
};
